import { render, staticRenderFns } from "./WhatsappDetailInfo.vue?vue&type=template&id=f732f5f4&"
import script from "./WhatsappDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./WhatsappDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports